import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class NotificationService {
  getNotificationData: BehaviorSubject<any> = new BehaviorSubject({});
  uaInfo: any;
  constructor() {
  }
  setNotificationData(notification: any) {
    this.getNotificationData.next(notification);
  }
  notificationObserval() {
    return this.getNotificationData.asObservable();
  }
}